import {IContactNode, IEntityInfoResponse, IEntityNode} from "../types";
import gql from 'graphql-tag';
import {client} from "./client";
import {RequestEntityInfo} from "../../schema/RequestEntityInfo";

type EntityWithContacts = Array<IEntityNode & {contacts: IContactNode[]}>

export async function requestEntityInfo (fullUid: string):
    Promise<EntityWithContacts> {
    try {
        const result: IEntityInfoResponse = await client.query({
            query: gql`${RequestEntityInfo}`,
            variables: {
                fullUid,
            }
        });
        return mapNodes(result.data.allEntities.nodes);
    } catch (e) {
        return [];
    }
}

type mapNodesType = IEntityInfoResponse['data']['allEntities']['nodes']
type contactNodeType = mapNodesType[0]['entitycontactsByFullUid']['nodes'][0];

function mapNodes (nodes: mapNodesType = []): EntityWithContacts {
    return nodes.map(node => ({
        ...node,
        contacts: node.entitycontactsByFullUid.nodes.map(
            (node: contactNodeType) => ({
                    ...node.contactByPocid,
                    entitycontactId: node.objectid
                })
        ),
        type: node.layerByLayerid.type,
        layername: node.layerByLayerid.layername,
        entitycontactsByFullUid: undefined,
    }))
}
